import { States } from "../../../__generated__/types";
import { StepFormContainer } from "../../../components/step-form";
import { DropdownSelect } from "../../../components/dropdown-select";
import { HdgTextInput } from "../../../components/hdg-text-input";
import { AddressAutocomplete } from "../../../components/address-autocomplete";
import { StepBars } from "../../../components/step-bars";

export const BusinessInformationFieldset = ({
  isValid,
  step,
  setNextStep,
  setStep,
  setBusinessName,
  setBusinessAddress,
  setBusinessZipCode,
  setBusinessCity,
  setBusinessState,
  setBusinessWebsite,
  businessName,
  businessAddress,
  businessZipCode,
  businessCity,
  businessState,
  businessWebsite,
}: {
  isValid: boolean;
  step: number;
  setNextStep: () => void;
  setStep: (value: number) => void;
  setBusinessName: (value: string) => void;
  setBusinessAddress: (value: string) => void;
  setBusinessZipCode: (value: string) => void;
  setBusinessCity: (value: string) => void;
  setBusinessState: (value: States) => void;
  setBusinessWebsite: (value: string) => void;
  businessName?: string;
  businessAddress?: string;
  businessZipCode?: string;
  businessCity?: string;
  businessState?: States;
  businessWebsite?: string;
}) => {
  return (
    <StepFormContainer
      step={4}
      visible={step === 4}
      isValid={isValid}
      onSubmit={setNextStep}
      onBack={() => setStep(3)}
    >
      <StepBars
        stepCount={3}
        currentStep={2}
        title="Business Information"
      />
      <HdgTextInput
        label="Company or Organization Name"
        name="businessName"
        value={businessName}
        onChange={setBusinessName}
      />

      <AddressAutocomplete
        label="Business Street Address"
        variant="outlined"
        fullWidth
        value={businessAddress || ""}
        placeholder="Start typing your business address..."
        onAddressSelect={(addressComponents) => {
          
          // Auto-fill business address fields based on Google Places result
          if (addressComponents.formattedAddress) {
            // Set the main address field to street address
            const streetAddress = [
              addressComponents.streetNumber,
              addressComponents.route
            ].filter(Boolean).join(' ');
            setBusinessAddress(streetAddress || addressComponents.formattedAddress);
          }
          
          // Auto-fill city
          if (addressComponents.locality) {
            setBusinessCity(addressComponents.locality);
          }
          
          // Auto-fill state
          if (addressComponents.administrativeAreaLevel1) {
            setBusinessState(addressComponents.administrativeAreaLevel1 as States);
          }
          
          // Auto-fill zip code
          if (addressComponents.postalCode) {
            setBusinessZipCode(addressComponents.postalCode);
          }
        }}
        onInputChange={(value) => setBusinessAddress(value)}
        style={{ marginBottom: '16px' }}
      />
      <HdgTextInput
        label="Zip Code"
        name="businessZipCode"
        value={businessZipCode}
        onChange={setBusinessZipCode}
      />
      <HdgTextInput
        label="City"
        name="businessCity"
        value={businessCity}
        onChange={setBusinessCity}
      />

      <DropdownSelect<States>
        name="businessState"
        label="State"
        value={businessState}
        onChange={setBusinessState}
        options={Object.values(States)}
      />

      <HdgTextInput
        label="Business Website"
        name="businessWebsite"
        value={businessWebsite}
        onChange={setBusinessWebsite}
      />
    </StepFormContainer>
  );
};
